import { isNumber } from 'lodash';
import React, { FC, useRef, useEffect, useState } from 'react';
import InputBox from 'src/components/atoms/input/DefInputBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import CheckBox from 'src/components/atoms/CheckBox';
import HelpButton from 'src/components/atoms/buttons/HelpButton';
import Description from 'src/components/molecules/table/Description/MedicalExpense';
import DefLabel from 'src/components/atoms/label/LabelContnet';
import { useQueryClient } from '@tanstack/react-query';
import { medicalDataStore } from 'src/store/medicalFee';
import { getMemberInfo } from 'src/utils/common';
import { getBizNo, formatBizNo, validateBizNo } from 'src/utils/charSet';
import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import {
  settlementNtsDataStore,
  ntsFileDataStore,
  settlementDataStore,
} from 'src/store/settlementInfo';
import { fetchInsertMedicalData, fetchUpdateMedicalData } from 'src/fetch/stepC/medical';
import { addComma } from 'src/utils/common';

interface Props {
  data: any;
  type: string;
}
const GridAdd: FC<Props> = ({ data, type }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);

  const storeData = medicalDataStore((state: any) => state.result).data || [];
  const storeInitPayload = medicalDataStore((state: any) => state.initPayload);
  const storePayload = medicalDataStore((state: any) => state.payload);
  const storePayloadBind = medicalDataStore((state: any) => state.bindPayload);
  const bindStoreParam = medicalDataStore((state: any) => state.param);
  const bindStoreBindParam = medicalDataStore((state: any) => state.bindParam);

  // 정산결과
  const settlementBindParam = settlementDataStore((state: any) => state.bindParam);
  const settlementParam = settlementDataStore((state: any) => state.param);
  // 정산결과(NTS)
  const ntsInfoBindParam = settlementNtsDataStore((state: any) => state.bindParam);
  const ntsInfoParam = settlementNtsDataStore((state: any) => state.param);
  // NTS 업로드파일 데이터
  const ntsFileBindParam = ntsFileDataStore((state: any) => state.bindParam);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);

  useEffect(() => {
    if (type === 'insert') {
      storePayloadBind({ ...storeInitPayload });
    } else {
      const storeData = data.infoData;
      for (const key in storePayload) {
        if (storeData) storePayload[key] = storeData[key];
      }
      storePayloadBind({ ...storePayload, name: data.name });
    }
  }, [storeData]);

  // const familyDataSet = storeData.filter((item: any) => item.infoData.length === 0);
  const familyDataSet = storeData;
  const familySet = familyDataSet.map((item: any) => {
    return { id: item.family_seqid, value: item.name };
  });
  familySet.unshift({ id: '', value: '선택' });
  const checkedFamily =
    storePayload.family_seqid === 0
      ? familySet[0]
      : { id: storePayload.family_seqid, value: storePayload.name };

  const familySelect = {
    checked: checkedFamily,
    options: familySet,
  };

  const dataTypeSet = [
    { id: '', value: '선택' },
    {
      id: '1',
      value: '국세청 제공',
    },
    {
      id: '2',
      value: '국민건강보험 공단',
    },
    {
      id: '3',
      value: '진료비, 약제비',
    },
    {
      id: '4',
      value: '장기요양급여 비용',
    },
    {
      id: '5',
      value: '기타 의료비 영수증',
    },
  ];
  const checkedDataType =
    storePayload.family_seqid === 0
      ? dataTypeSet[0]
      : {
          id: storePayload.data_type,
          value: dataTypeSet.find((item: any) => item.id === storePayload.data_type)?.value,
        };

  const dataTypeSelect: any = {
    checked: checkedDataType,
    options: dataTypeSet,
  };
  const viewData = data || [];

  const help = {
    content: `
      <div className="_hint_content">
        <div className="_item">① 진찰 . 진료 . 질병예방을 위한 의료기관지출액 (미용·성형수술을 위한 비용 제외)</div>
        <div className="_item">② 치료 . 요양을 위한 의약품(한약 포함)구입비 (건강증진을 위한 의약품 제외)</div>
        <div className="_item">③ 장애인보장구 구입 . 임차비용 (제출서류: 사용자의 성명을 판매자가 확인한 영수증)</div>
        <div className="_item">④ 의사 . 치과의사 . 한의사 등의 처방에 따른 의료기기 구입.임차비용</div>
        <div className="_item">(제출서류: 처방전 or 판매자 또는 임대인이 발행한 의료기기명이 기재된 의료비영수증)</div>
        <div className="_item">⑤ 시력보정용 안경 . 콘텍트렌즈 구입비(기본공제대상자(연령ㆍ소득금액 제한 없음) 1인당 연 50만원 이내의 금액)</div>
        <div className="_item">⑥ 보청기구입비 (제출서류: 사용자의 성명을 판매자가 확인한 영수증)</div>
        <div className="_item">⑦ 「노인장기요양보험법」제40조 제1항 및 제40조 제2항 제3호에 따라 실제 지출한 본인일부부담금</div>
        <div className="_item">⑧ 산후조리원에 산후조리 및 요양의 대가로 지급하는 비용으로서 출산1회당 200만원 이내 금액 (총급여액 7천만원 이하자만 해당)</div>
        <div className="_item">⑨「모자보건법」에 따른 미숙아 및 선천성 이상아 치료를 위해 지급한 의료비(제출서류: 진단서 또는 출생증명서(미숙아 선천성이상아))</div>
      </div>
      `,
    title: '공제 대상 항목',
  };
  const help_t2 = {
    content: `
      <div className="_hint_content">
        <div className="_item">* 사업자 등록번호(주민등록번호)는 '-'를 제외한 숫자만 입력해야 합니다.</div>
      </div>
      `,
    title: '사업자등록번호',
  };

  const confirmSelect = (item: any, field: string) => {
    console.log(item, field);
    if (field === 'family_seqid') {
      storePayloadBind({ ...storeInitPayload, family_seqid: item.id, name: item.value });
    } else {
      storePayload[field] = item.id;
      storePayloadBind({ ...storePayload });
    }
  };

  const confirmEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;

    // validation
    const { status } = validationParam(param, 'update');
    if (!status) {
      return false;
    }
    //사업번호 - 제거
    if (param.co_num.indexOf('-') !== -1) {
      param.co_num = param.co_num.replaceAll('-', '');
    }

    // return false;
    fetchInsertMedicalData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  // UPDATE
  const modifyEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;

    // validation
    const { status } = validationParam(param, 'update');
    if (!status) {
      return false;
    }
    //사업번호 - 제거
    if (param.co_num.indexOf('-') !== -1) {
      param.co_num = param.co_num.replaceAll('-', '');
    }

    fetchUpdateMedicalData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  const validationParam = (payloadSet: any, type: string) => {
    const resSet = { errText: { main: '', sub: '' }, status: true };
    console.log('validationParam:::', payloadSet);
    const requiredSet = [
      { id: 'name', label: '성명' },
      { id: 'data_type', label: '의료증빙 구분' },
      { id: 'trade_nm', label: '지급처상호' },
    ];
    // Check Required
    for (const item in payloadSet) {
      if (requiredSet.some(req => req.id === item)) {
        let chkValue = payloadSet[item];
        if (typeof chkValue === 'string') chkValue = chkValue.trim() || '';
        if (typeof chkValue === 'number') chkValue = chkValue || 0;
        if (chkValue === '' || chkValue === 0) {
          const label = requiredSet.find((el: any) => el.id === item)?.label;
          resSet.errText.main = `'${label}' 은 필수입력 입니다.`;
          resSet.errText.sub = '해당 값을 입력해 주세요.';
          resSet.status = false;
        }
      }
    }

    //사업자등록번호 체크
    // 123-45-67891
    // 314-15-92650
    // 870-10-23454
    // 555-66-77780
    // 901-23-45674
    if (!validateBizNo(payloadSet.co_num || '')) {
      const targetName = '사업자등록번호';
      resSet.errText.main = `잘못된 ${targetName}입니다.`;
      resSet.errText.sub = `${targetName}를 다시 입력해 주세요.`;
      resSet.status = false;
    }

    if (!resSet.status)
      errorModalState({
        data: { mainTitle: resSet.errText.main, subTitle: resSet.errText.sub },
        active: '_active',
      });

    return resSet;
  };

  const checkClickEvt = (e: any, status: string, field?: string) => {
    storePayload.is_glass = 'N';
    storePayload.is_sf_practice = 'N';
    storePayload.is_postpartum = 'N';
    storePayload.is_prem_baby = 'N';
    storePayload.is_ph_insu = 'N';

    if (field) {
      const vType = status === 'on' ? 'N' : 'Y';
      storePayload[field] = vType;
      storePayloadBind(storePayload);
    }
  };

  const inpStrChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const chkValue = e.target?.value || '';
    storePayload[key] = chkValue;
    storePayloadBind({ ...storePayload });
  };
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let chkValue = e.target?.value || '';
    chkValue = chkValue.replaceAll(',', '');
    const chkNum = Number(chkValue);
    if (chkNum || chkNum === 0) {
      storePayload[key] = chkNum;
      storePayloadBind({ ...storePayload });
    }
  };
  const inpBizChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const chkValue = e.target?.value || '';

    const resNum = formatBizNo(chkValue);
    console.log(chkValue, resNum);
    if (resNum === false) return false;
    storePayload[key] = resNum;
    storePayloadBind({ ...storePayload });
  };

  return (
    <div className="_add_credit_layout">
      {/* <div className="_desc_div">
        <div className="_main">총 급여의 25% : 10,000,000</div>
        <div className="_sub">신용카드등은 총급여의 25% 이상이어야 공제 가능합니다.</div>
      </div> */}
      <div className="_title_div">
        <div className="_title">공제 대상 항목</div>
        <div className="_help_div">
          <HelpButton content={help.content} title={help.title} styleDef={{ width: '680px' }} />
        </div>
      </div>
      <div className="_inp_div">
        <div className="_opt_div">
          <div className="_item" style={{ zIndex: 20, width: '450px' }}>
            {type === 'insert' ? (
              <LabelSelect
                label="피보험자"
                select={familySelect}
                labelStyle={{ width: '200px' }}
                boxStyleDef={{ width: 'calc(100% - 200px)' }}
                confirmEvent={confirmSelect}
                field="family_seqid"
              />
            ) : (
              <div className="_title_div">
                <DefLabel
                  label="성명"
                  content={storePayload.name || ''}
                  styleDef={{ color: '#333', fontWeight: '600', fontSize: '15px' }}
                  labelStyleDef={{
                    fontWeight: '500',
                    fontSize: '14px',
                    width: '205px',
                    paddingRight: '10px',
                  }}
                />
              </div>
            )}
          </div>
          <div className="_item" style={{ zIndex: 15, width: '450px' }}>
            <LabelSelect
              label="의료증빙 구분"
              select={dataTypeSelect}
              labelStyle={{ width: '200px' }}
              boxStyleDef={{ width: 'calc(100% - 200px)' }}
              confirmEvent={confirmSelect}
              field="data_type"
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpStrChangeEvt(e, 'trade_nm')}
              required="Y"
              label="지급처상호"
              status={''}
              labelPosition="left"
              value={storePayload.trade_nm}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'amt')}
              required="Y"
              label="지출금액"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <div className="_item_set" style={{ zIndex: 5, width: '450px' }}>
              <InputBox
                changeEvt={e => inpBizChangeEvt(e, 'co_num')}
                // inputRef={inpRef}
                label="사업자등록번호"
                status={''}
                labelPosition="left"
                value={storePayload.co_num}
                required="Y"
                // value={getBizNo(storePayload.co_num)}
                placeholder="값을 입력하세요"
                labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
                // styleDef={boxStyle}
                inpStyleDef={{ textAlign: 'right' }}
              />
            </div>
            {/* <div className="_item_set" style={{ zIndex: 5, width: '20px', marginLeft: 'auto' }}>
              <HelpButton
                content={help_t2.content}
                title={help_t2.title}
                styleDef={{ width: '380px' }}
              />
            </div> */}
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'expt_htx_pdf')}
              // inputRef={inpRef}
              label="PDF제외금액"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.expt_htx_pdf)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'cnt')}
              // inputRef={inpRef}
              label="건수"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.cnt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
        </div>
        <div className="_set_div">
          <div className="_item _chk">
            <CheckBox
              label="안경구입비 여부"
              selected={storePayload.is_glass === 'Y' ? 'on' : 'off'}
              btnClickEvt={checkClickEvt}
              labelStyleDef={{ color: '#333', fontWeight: '500', width: '100px' }}
              field="is_glass"
            />
          </div>
          <div className="_item _chk">
            <CheckBox
              label="난임시술비 여부"
              selected={storePayload.is_sf_practice === 'Y' ? 'on' : 'off'}
              btnClickEvt={checkClickEvt}
              labelStyleDef={{ color: '#333', fontWeight: '500', width: '100px' }}
              field="is_sf_practice"
            />
          </div>
          <div className="_item _chk">
            <CheckBox
              label="산후조리원비 여부"
              selected={storePayload.is_postpartum === 'Y' ? 'on' : 'off'}
              btnClickEvt={checkClickEvt}
              labelStyleDef={{ color: '#333', fontWeight: '500', width: '130px' }}
              field="is_postpartum"
            />
          </div>
          <div className="_item _chk">
            <CheckBox
              label="선천성 미숙아 여부"
              selected={storePayload.is_prem_baby === 'Y' ? 'on' : 'off'}
              btnClickEvt={checkClickEvt}
              labelStyleDef={{ color: '#333', fontWeight: '500', width: '130px' }}
              field="is_prem_baby"
            />
          </div>
          <div className="_item _chk">
            <CheckBox
              label="실손의료보험금 여부"
              selected={storePayload.is_ph_insu === 'Y' ? 'on' : 'off'}
              btnClickEvt={checkClickEvt}
              labelStyleDef={{ color: '#333', fontWeight: '500', width: '130px' }}
              field="is_ph_insu"
            />
          </div>
        </div>
      </div>
      <div className="_description">
        <Description />
      </div>
      <div className="_btn_div">
        {type === 'insert' ? (
          <DefaultButton
            text="내역 추가"
            styleDef={{ width: '250px' }}
            clickEvent={e => confirmEvt()}
            icon=""
            type="type5"
          />
        ) : (
          <DefaultButton
            text="내역 변경"
            styleDef={{ width: '250px' }}
            clickEvent={e => modifyEvt()}
            icon=""
            type="type3"
          />
        )}
      </div>
    </div>
  );
};

export default GridAdd;
